import React from 'react'
import { Grid } from '@mui/material'
import DownloadCSVButton from '../../report/export/DownloadCSVButton';
import ReportDataSummary from "../../report/redesigned/ReportDataSummary";
import {
  getSupplierAccountsReceivableCSVReport,
  getSupplierAccountsReceivableBuyerLocationPdf
} from '../../../requests/reports/invoices/supplier-accounts-receivable-requests';
import {SupplierAccountsReceivableRequestType} from "../../../types/reports/SupplierAccountsReceivableRequestType";

interface SupplierAccountsReceivableSummaryProps {
  count: number;
  title: string;
  setExpandedItems: (items: Record<string, unknown>) => void;
  setExpandedAll: () => void;
  isShowCollapseButton?: boolean;
  handleExpandAll: () => void;
  hasExpandedItems: boolean;
  query: SupplierAccountsReceivableRequestType;
}

const isBuyerStatementPdfAvailable = (query: SupplierAccountsReceivableRequestType): boolean => {
  return !(query?.buyerAccountId && query?.locationId);
}

const SupplierAccountsReceivableSummary = ({
    count,
    title,
    setExpandedItems,
    setExpandedAll,
    isShowCollapseButton = false,
    handleExpandAll,
    hasExpandedItems,
    query
}: SupplierAccountsReceivableSummaryProps) => {

  return (
    <ReportDataSummary
      count={count}
      title={title}
      setExpandedItems={setExpandedItems}
      setExpandedAll={setExpandedAll}
      isShowCollapseButton={isShowCollapseButton}
      handleExpandAll={handleExpandAll}
      hasExpandedItems={hasExpandedItems}
    >
      <Grid item container lg xs={12} gap={2} justifyContent={'end'} wrap={'nowrap'}>
        <Grid item>
          <DownloadCSVButton
            title='Download Report'
            reportUrl={getSupplierAccountsReceivableCSVReport(query)}
          />
        </Grid>
        <Grid item>
          <DownloadCSVButton
            title='Download Buyer Statement PDF'
            reportUrl={getSupplierAccountsReceivableBuyerLocationPdf(query)}
            disabled = {isBuyerStatementPdfAvailable(query)}
          />
        </Grid>
      </Grid>
    </ReportDataSummary>
  )
}

export default SupplierAccountsReceivableSummary
